import React, {useEffect, useRef, useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import logo from 'assets/salvo-logo.png'
import useCompany from "../../../Hooks/useCompany";
import WeekReportTableBriefPdf from "./WeekReportTableBriefPdf";
import useMyTranslation from "../../../Hooks/useMyTranslation";

import css from '../css/PdfHoursExport.module.css'
import {getClient} from "../../../API/axiosClient";
import {getGeofenceExtrasWithValues} from "../../../API/companyApi";
import DaysTablePdf from "./DaysTablePdf";
import ConditionalRender from "../../ConditionalRender";
import {getAllocationsForTransactions} from "../../../API/timelineApi";

const PdfHoursExport = ({ msisdn, transactions, overlaps, events, selectedWeek, onExportStateChange, shouldExport, showDaysBreakdown = false, hidden = true}) => {
    const componentRef = useRef();
    const company = useCompany()
    const t = useMyTranslation('export.pdf')
    const axios = getClient()

    const defaultLocale = 'nl-NL'

    const [geofenceExtras, setGeofenceExtras] = useState([])

    const [allAllocations, setAllAllocations] = useState([]);
    useEffect(() => {
        const fetchAllocations = async () => {
            if(transactions.length > 0)
            {
                const response = await getAllocationsForTransactions(transactions.map(transaction => transaction.id), transactions[0].msisdn)
                setAllAllocations(response.data);
            }
        }
        fetchAllocations();
    }, [transactions]);

    useEffect(() => {
        async function getGeofenceExtras()
        {
            const geofenceIds = [...new Set(transactions.map(t => t.geofenceId))];
            const response = await getGeofenceExtrasWithValues(geofenceIds)
            setGeofenceExtras(response.data)
        }

        getGeofenceExtras()
    }, [transactions])

    useEffect(() => {
        if(shouldExport)
        {
            handleExportToPDF()
        }
    }, [shouldExport]);

    const handleExportToPDF = async () => {
        if (!componentRef.current) return;

        // Access the DOM element directly
        const domElement = componentRef.current;

        // Extract the full HTML from the DOM element
        const outerHTML = domElement.outerHTML;

        // Inject your CSS dynamically
        const styleContent = `
        .${css.header} {
            padding: 10px;
            background-color: #165f82;
            color: white;
        }
        .${css.header} h4 {
            margin: 0;
        }
        .${css.underHeader} {
            padding: 10px;
            background-color: #caeafd;
        }
        .${css.body} {
            padding: 20px;
        }
        .${css.tableHeader} {
            color: white;
        }
        
        .${css.tableHeader} {
            background-color: #0f4a67 !important;
            color: white !important;
            vertical-align: top;
            line-height: 1.2;
            text-transform: none;
            font-weight: bold;
        }
        
        .${css.dayColumn} {
            background-color: #165f82 !important;
            color: white !important;
            vertical-align: top;
            line-height: 1.2;
            font-weight: bold;
            text-transform: none;
            white-space: pre-line;
        }
         
        .${css.weekTableHeader} {
            color: white !important;
            background-color: #0c769f !important;
            font-weight: bold;
        }
        
        .${css.dayTableRowEmphasis} {
            background-color: rgba(64, 175, 220, 0.35) !important;
        }
        
        .${css.topMid} {
            vertical-align: top;
            text-align: center;
        }
        
        .${css.midX} {
            text-align: center;
        }
        
        #${css.weekReportTable} td {
            background-color: #ececec;
            border-color: white;
            border-width: 1px;
        }

        #${css.weekReportTable} th {
            border-bottom: 5px solid white;
            font-size: smaller;
        }
        
        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
            'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
            sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        
        code {
          font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
            monospace;
        }
    `;

        // Build the full HTML content to send to the Azure Function
        const htmlContent = `
            <html>
                <head>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" crossorigin="anonymous">
                    <style>${styleContent}</style>
                </head>
                <body>
                    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js" crossorigin="anonymous"></script>
                    ${outerHTML}
                </body>
            </html>
        `;

        try {
            onExportStateChange && onExportStateChange(true);

            // Call Azure Function API
            const response = await axios.post(
                'v1/hours/export/pdf',
                {
                    htmlContent,
                    format: 'A2',
                    landscape: true,
                },
                {
                    responseType: 'arraybuffer', // Expect a PDF file in binary format
                }
            );

            // Download the PDF
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = t('fileName') + `-${selectedWeek.year}-${selectedWeek.week}` + '.pdf';
            link.click();

            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Failed to generate PDF:', error);
        } finally {
            onExportStateChange && onExportStateChange(false);
        }
    };


    if (!msisdn) {
        return null;
        // return hidden ? null : <div>Selecteer een werknemer</div>
    }

    if (!selectedWeek || !selectedWeek.startDate || !selectedWeek.endDate) {
        return null;
        // return hidden ? null : <div>Selecteer een week</div>
    }

    if (!company)
        return null;
        // return hidden ? null : <LoadingSpinner small/>

    const selectedWeekIsActive = selectedWeek.startDate <= new Date() && selectedWeek.endDate >= new Date();

    return (
        <div>
            {/*<div className={'d-flex justify-content-center mb-3'}><Button onClick={handleExportToPDF}>Print this*/}
            {/*    out!</Button></div>*/}
            <div className={hidden ? 'd-none' : ''}>
                <Container fluid ref={componentRef} className={'p-0'}>
                    <div className={css.header}>
                        <Row>
                            <Col className={'d-flex align-items-center'}>
                                <h4 className={'fw-bold'}>{t('title')}</h4>
                            </Col>
                            <ConditionalRender condition={selectedWeekIsActive}>
                                <Col className={'d-flex justify-content-center align-items-center'}>
                                    <span className={'h3 fst-italic mb-0 text-lowercase'}>{t('currentWeekActive')}</span>
                                </Col>
                            </ConditionalRender>
                            <Col className='d-flex justify-content-end'>
                                <img style={{width: 120}} src={logo} alt={"logo"}/>
                            </Col>
                        </Row>
                    </div>
                    <div className={css.underHeader}>
                        <Row>
                            <Col className={'d-flex flex-column justify-content-center'}>
                                <h4 className={'mb-0 fw-bold'}>Week {selectedWeek.week} {selectedWeek.year}</h4>
                                <small className={'text-capitalize'}>{selectedWeek.startDate.toLocaleDateString(defaultLocale)} — {selectedWeek.endDate.toLocaleDateString(defaultLocale)}</small>
                            </Col>
                            <Col className={'d-flex flex-column justify-content-center align-items-center'}>
                                <span className={'fw-bold'}>{msisdn.fullName}</span>
                                <span>{msisdn.msisdn}</span>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <h4 className={'fw-bold'}>{company.name}</h4>
                            </Col>
                        </Row>
                    </div>

                    <div className={css.body}>
                        <ConditionalRender condition={selectedWeek && selectedWeek.week}>
                            <Row>
                                <Col>
                                    <WeekReportTableBriefPdf msisdn={msisdn} transactions={transactions} selectedWeek={selectedWeek} events={events} geofenceKeys={geofenceExtras}/>
                                </Col>
                            </Row>
                        </ConditionalRender>

                        <ConditionalRender condition={showDaysBreakdown}>
                            <Row className={'mt-2'}>
                                <Col>
                                    <DaysTablePdf transactions={transactions} events={events} allocations={allAllocations} overlaps={overlaps} selectedWeek={selectedWeek}/>
                                </Col>
                            </Row>
                        </ConditionalRender>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default PdfHoursExport;
